export const SHOW_ARCHIVED_TOGGLE = "COMMENTS/SHOW_ARCHIVED_TOGGLE";

export default (state = { isShowingArchived: false }, { type, data }) => {
    switch (type) {
    case SHOW_ARCHIVED_TOGGLE:
        if (data.isNextStateShowingArchived === undefined){
            return { ...state, isShowingArchived: !state.isShowingArchived };
        }
        return { ...state, isShowingArchived: data.isNextStateShowingArchived };
    default: return state;
    }
};

export const toggleShowArchived = isNextStateShowingArchived => ({ type: SHOW_ARCHIVED_TOGGLE, data: { isNextStateShowingArchived } });
